import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';

type Post = { id: string; heading: string; url: string; author: string; timeStamp: string; published: boolean };
const fmt = (d: string) => { const x = new Date(d); return x.getDate() + ". " + (x.getMonth() + 1) + ". " + x.getFullYear(); };

export default function AdminBlog() {
    const [posts, setPosts] = useState<Post[]>([]);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { load(); }, []);
    async function load() { try { setPosts(await (await api.adminBlogApi.list()).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); } }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Blog</h1><p>Články na veřejném webu</p></div>
                <button className="aBtn" onClick={() => navigate("/admin/blog/new")}>+ Nový článek</button>
            </div>
            <table className="aTable">
                <thead><tr><th>Nadpis</th><th>Autor</th><th>URL</th><th>Datum</th></tr></thead>
                <tbody>
                    {posts.map(p => (
                        <tr key={p.id} onClick={() => navigate("/admin/blog/" + p.id)}>
                            <td>{p.heading || <span className="muted">(bez nadpisu)</span>}{!p.published && <span className="draftBadge">Koncept</span>}</td>
                            <td>{p.author}</td>
                            <td><span className="muted">{p.url}</span></td>
                            <td>{fmt(p.timeStamp)}</td>
                        </tr>
                    ))}
                    {loaded && posts.length === 0 && <tr><td colSpan={4} className="muted">Žádné články.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}
